module.exports = __webpack_public_path__ + "static/media/loimg.cc69c5cb.gif";